/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S16_P1_AInputs */

const tr_mesafeli_s16_p1_a = /** @type {(inputs: Mesafeli_S16_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı, Müşteri'nin Platform'a yüklediği üçüncü kişi verileri bakımından veri işleyen; kendi Müşterilerinden topladığı bilgiler bakımından veri sorumlusu sıfatıyla hareket eder. Detaylı bilgi için`)
};

const en_mesafeli_s16_p1_a = /** @type {(inputs: Mesafeli_S16_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider acts as data processor in respect of third-party data uploaded to the Platform by the Customer, and as data controller in respect of the information it collects from its own Customers. For detailed information see the`)
};

const de_mesafeli_s16_p1_a = /** @type {(inputs: Mesafeli_S16_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter handelt in Bezug auf Daten Dritter, die der Kunde auf die Plattform hochlädt, als Auftragsverarbeiter und in Bezug auf Informationen, die er von seinen eigenen Kunden erhebt, als Verantwortlicher. Ausführliche Informationen finden Sie unter`)
};

const ru_mesafeli_s16_p1_a = /** @type {(inputs: Mesafeli_S16_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик выступает как обработчик данных в отношении данных третьих лиц, загруженных Клиентом на Платформу, и как оператор данных в отношении сведений, которые он собирает от собственных Клиентов. Подробную информацию см. на страницах`)
};

/**
* | output |
* | --- |
* | "The Provider acts as data processor in respect of third-party data uploaded to the Platform by the Customer, and as data controller in respect of the informa..." |
*
* @param {Mesafeli_S16_P1_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s16_p1_a = /** @type {((inputs?: Mesafeli_S16_P1_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S16_P1_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s16_p1_a(inputs)
	if (locale === "de") return de_mesafeli_s16_p1_a(inputs)
	if (locale === "ru") return ru_mesafeli_s16_p1_a(inputs)
	return tr_mesafeli_s16_p1_a(inputs)
});